import { styled } from "../gatsby-theme-stitches/config"

export const Button = styled("button", {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  borderRadius: "$s",
  border: "none",
  cursor: "pointer",
  background: "$border",
  color: "$textSecondary",
  transition: "0.2s ease all",
  "&:hover": {
    background: "$textSecondary",
    color: "$border",
  },
  variants: {
    variant: {
      normal: {
        px: "$m",
        py: "$xs",
      },
      icon: {
        width: 31,
        height: 31,
      },
    },
  },
})
